<template>
  <div>
    <h1>Scavenger Hunt</h1>
    <br />
    <p>
      Welcome to the ultimate exploration game for the season! This online
      multiplayer game lets players interact with their environments in a new
      way. Players navigate the real world, stopping by landmarks to receive
      awards. The game can be played in single player or multiplayer mode. The
      player to solve all the riddles in the shortest time will be declared
      winner. Reach all the landmarks in the shortest possible time to be
      declared as the winner.
    </p>
    <br />
    <h1>Contributors</h1>
    <p>Group 17: Jake TerHark, Rishi Raj, Smit Patel, Cole Cunningham</p>
    <p></p>
  </div>
</template>

<script>
export default {
  name: "About"
};
</script>

<style scoped></style>
